import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Fab from "@material-ui/core/Fab"
import { CircularProgress } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}))

export default function CFloatButton(props) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Fab
        color={props.color || "primary"}
        aria-label={props.label || ""}
        disabled={props.disabled || false}
        onClick={props.onClick}
      >
        {props.loading ? <CircularProgress /> : <> {props.children}</>}
      </Fab>
    </div>
  )
}
